// src/components/ui/ComparisonRow.tsx
import React from "react";

interface ComparisonRowProps {
  feature: string;
  traditionalSim: string;
  alodataEsim: string;
}

const ComparisonRow: React.FC<ComparisonRowProps> = ({
  feature,
  traditionalSim,
  alodataEsim,
}) => (
  <tr className="hover:bg-gray-50">
    <td className="py-4 px-6 border-b text-sm md:text-base text-gray-700">
      {feature}
    </td>
    <td className="py-4 px-6 border-b text-sm md:text-base text-gray-700">
      {traditionalSim}
    </td>
    <td className="py-4 px-6 border-b text-sm md:text-base text-gray-700">
      {alodataEsim}
    </td>
  </tr>
);

export default ComparisonRow;
